<template>
  <div>
    <ul class="p-project-edit-list">
      <li class="p-project-edit-list__item">
        <div class="c-input">
          <div class="c-input__title u-w190">大型画像</div>
          <div>
            <div class="p-dialog-option-v2__spec">※ 形式: PNG / JPEG / GIF、容量: 256KB 以下 (PNG/JPEG は超過時に自動圧縮します)</div>
            <div class="p-dialog-option-v2__spec">※ スマホ(画面の横幅が430px以下)では表示されません</div>
            <div class="p-dialog-option-v2__image-row">
              <input
                v-model="imageUrl"
                type="text"
                class="c-input__item"
                readonly
              />
              <label class="c-upload__label p-dialog-option-v2__file-btn" title="ファイルのアップロード">
                <input
                  ref="imageInput"
                  type="file"
                  name="banner_image"
                  value=""
                  accept="image/png,image/jpeg,image/gif"
                  @change="selectImageFile"
                />
                <span class="c-upload__btn">
                  <Icon name="upload" :size="20" color="#57606a" />
                </span>
              </label>
              <button type="button" class="p-dialog-option-v2__clear-btn p-dialog-option-v2__clear-btn--multiline" @click="clearImage">画像<br />なし</button>
            </div>
            <div class="c-error" :class="{ 'is-active': errors.imageUrl !== '' }">
              <div class="c-error__text">{{ errors.imageUrl }}</div>
            </div>
          </div>
        </div>
      </li>
      <li class="p-project-edit-list__item">
        <div class="c-input">
          <div class="c-input__title u-w190">アイコン画像</div>
          <div>
            <div class="p-dialog-option-v2__spec">※ 形式: PNG / JPEG、サイズ: 192×192px、容量: 8KB 以下 (超過時は自動トリミング・圧縮します)</div>
            <div class="p-dialog-option-v2__image-row">
              <input
                v-model="iconUrl"
                type="text"
                class="c-input__item"
                readonly
              />
              <label class="c-upload__label p-dialog-option-v2__file-btn" title="ファイルのアップロード">
                <input
                  ref="iconInput"
                  type="file"
                  name="icon_image"
                  value=""
                  accept="image/png,image/jpeg"
                  @change="selectIconFile"
                />
                <span class="c-upload__btn">
                  <Icon name="upload" :size="20" color="#57606a" />
                </span>
              </label>
              <button type="button" class="p-dialog-option-v2__clear-btn p-dialog-option-v2__clear-btn--multiline" @click="resetIcon">初期<br />画像</button>
              <button type="button" class="p-dialog-option-v2__clear-btn p-dialog-option-v2__clear-btn--multiline" @click="clearIcon">画像<br />なし</button>
            </div>
            <div class="c-error" :class="{ 'is-active': errors.iconUrl !== '' }">
              <div class="c-error__text">{{ errors.iconUrl }}</div>
            </div>
            <div v-if="isDefaultIconUrl" class="c-error is-active">
              <div class="c-error__text">画像を変更してください</div>
            </div>
          </div>
        </div>
      </li>
      <li class="p-project-edit-list__item">
        <div class="c-input">
          <div class="c-input__title u-w190">タイトル</div>
          <div>
            <input
              v-model="title"
              type="text"
              class="c-input__item u-w680"
              :maxlength="maxLengths.title"
              :placeholder="defaultTitle"
              @keyup="generateScript"
              @input="checkTitleLength"
              @blur="updateScript()"
            />
            <div class="c-error" :class="{ 'is-active': errors.title !== '' }">
              <div class="c-error__text">{{ errors.title }}</div>
            </div>
          </div>
        </div>
      </li>
      <li class="p-project-edit-list__item">
        <div class="c-input">
          <div class="c-input__title u-w190">説明文</div>
          <div>
            <textarea
              v-model="description"
              class="c-input__item u-w680"
              rows="3"
              :maxlength="maxLengths.description"
              :placeholder="defaultDescription"
              @keyup="generateScript"
              @input="checkDescriptionLength"
              @blur="updateScript()"
            ></textarea>
            <div class="c-error" :class="{ 'is-active': errors.description !== '' }">
              <div class="c-error__text">{{ errors.description }}</div>
            </div>
          </div>
        </div>
      </li>
      <li class="p-project-edit-list__item">
        <div class="c-input">
          <div class="c-input__title u-w190">ボタンラベル<span class="p-dialog-option-v2__required">*</span></div>
          <div>
            <div class="p-dialog-option-v2__button-labels">
              <div class="p-dialog-option-v2__button-label-item">
                <span class="p-dialog-option-v2__button-label-caption">拒否ボタン</span>
                <input
                  v-model="denyLabel"
                  type="text"
                  class="c-input__item"
                  :maxlength="maxLengths.denyLabel"
                  :placeholder="defaultDenyLabel"
                  @keyup="generateScript"
                  @input="checkDenyLabelLength"
                  @blur="updateScript()"
                />
                <div class="c-error" :class="{ 'is-active': errors.denyLabel !== '' }">
                  <div class="c-error__text">{{ errors.denyLabel }}</div>
                </div>
                <div v-if="!denyLabel" class="p-dialog-option-v2__field-info">※「{{ defaultDenyLabel }}」が設定されます</div>
              </div>
              <div class="p-dialog-option-v2__button-label-item">
                <span class="p-dialog-option-v2__button-label-caption">許可ボタン</span>
                <input
                  v-model="allowLabel"
                  type="text"
                  class="c-input__item"
                  :maxlength="maxLengths.allowLabel"
                  :placeholder="defaultAllowLabel"
                  @keyup="generateScript"
                  @input="checkAllowLabelLength"
                  @blur="updateScript()"
                />
                <div class="c-error" :class="{ 'is-active': errors.allowLabel !== '' }">
                  <div class="c-error__text">{{ errors.allowLabel }}</div>
                </div>
                <div v-if="!allowLabel" class="p-dialog-option-v2__field-info">※「{{ defaultAllowLabel }}」が設定されます</div>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li class="p-project-edit-list__item">
        <div class="c-input">
          <div class="c-input__title u-w190">次回表示までの間隔</div>
          <div>
            <div class="p-dialog-option-v2__interval-row">
              <InputNumberSpinner
                :value="intervalDays"
                :min="intervalDaysRange.min"
                :max="intervalDaysRange.max"
                :step="1"
                :width="130"
                :height="40"
                @input="onIntervalDaysChange"
              />
              <span class="p-dialog-option-v2__interval-suffix">日後</span>
            </div>
            <div class="c-error" :class="{ 'is-active': errors.intervalDays !== '' }">
              <div class="c-error__text">{{ errors.intervalDays }}</div>
            </div>
          </div>
        </div>
      </li>
      <li class="p-project-edit-list__item">
        <div class="c-input">
          <div class="c-input__title u-w190">スタイル設定</div>
          <div class="p-dialog-option-v2__style-btn-row">
            <button
              class="c-btn c-btn--modal c-btn--blue p-dialog-option-v2__style-btn"
              type="button"
              @click="onOpenStyleModal"
            >
              <p class="c-btn__text">スタイル設定を開く</p>
            </button>
          </div>
        </div>
      </li>
      <li class="p-project-edit-list__item">
        <div class="c-textarea" style="align-items: normal;">
          <div class="c-textarea__title">オプションタグ</div>
          <textarea
            ref="scriptTextarea"
            v-tooltip.top-start="{
              content: showChangedTooltip ? '設定を更新しました。新しいオプションタグをページに設置して、変更を反映してください。' : '',
              show: showChangedTooltip,
            }"
            style="margin-left: auto;"
            class="c-textarea__item u-w630 u-h300"
            :name="data.copyId"
            :style="{ backgroundColor: isChanged ? '#d7eff5' : 'inherit' }"
            readonly
          >
                    </textarea>

          <button
            class="c-btn c-btn--circle"
            type="button"
            name="clip"
            value="add-user"
            @click="onClipClick($event)"
          >
            <div
              v-tooltip="{
                content: isCopied
                  ? 'コピーしました'
                  : 'クリップボードにコピー',
                hideTriggers: (triggers) => triggers.filter((trigger) => trigger !== 'click'),
              }"
              @click="toggleCopyText"
            >
              <div class="c-icon-circle c-icon-circle--gray-2 u-wh40">
                <div class="c-icon-circle__item c-icon-circle__item--white c-icon__item--alpha70 u-wh20">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <use xlink:href="/assets/img/sprite.svg#clipboard" />
                  </svg>
                </div>
              </div>
            </div>
          </button>
        </div>
      </li>
    </ul>
    <!-- プレオプトインダイアログV2 プレビュー -->
    <PreOptinDialogV2Preview v-if="showPreview" :dialog-values="dialogValues" @close="$emit('close-preview')" />
    <!-- プレオプトインスタイル設定ダイアログ -->
    <PreOptinDialogV2StyleModal
      :is-open="isStyleDialogOpen"
      :style-data="styleSettings"
      :is-preview-shown="showPreview"
      :has-icon="!!iconUrl"
      @update:style-data="onStyleUpdate"
      @close="onCloseStyleModal"
      @toggle-preview="$emit('toggle-preview')"
    />
    <!-- モーダル: 画像トリミング・圧縮(アイコン用) -->
    <ImageCropperModal ref="iconCropperModal" @cropped="onIconCropped" @cancelled="onIconCropCancelled" />
    <!-- モーダル: 画像圧縮(大型画像用) -->
    <ImageCompressModal
      ref="imageCompressModal"
      :max-file-size="262144"
      modal-description="画像サイズが256KBを超えています。<br>256KB以下に自動変換されます。"
      @compressed="onImageCompressed"
      @cancelled="onImageCompressCancelled"
    />
  </div>
</template>

<script>
import axios from "axios";
import PreOptinDialogV2Preview from '../molecules/PreOptinDialogV2Preview.vue';
import PreOptinDialogV2StyleModal from '../molecules/PreOptinDialogV2StyleModal.vue';
import InputNumberSpinner from '../atoms/InputNumberSpinner.vue';
import ImageCropperModal from './ImageCropperModal.vue';
import ImageCompressModal from './ImageCompressModal.vue';
import Icon from '../atoms/Icon.vue';
import { DEFAULT_OPTIN_DIALOG_ICON_URL } from '../../funcs/constants';
export default {
  components: { PreOptinDialogV2Preview, PreOptinDialogV2StyleModal, InputNumberSpinner, ImageCropperModal, ImageCompressModal, Icon },
  props: {
    copyId: String,
    showPreview: {
      type: Boolean,
      default: false,
    },
    projectIconUrl: {
      type: String,
      default: '',
    },
    isActive: {
      type: Boolean,
      default: true,
    },
    initialData: {
      type: Object,
      default: null,
    },
  },
  emits: ["close-preview","toggle-preview"],
  data() {
    return {
      data: {
        copyId: this.copyId,
      },

      imageUrl: '',
      iconUrl: '',
      title: '',
      description: '',
      denyLabel: '',
      allowLabel: '',
      intervalDays: 1,

      defaultTitle: '最新情報をいち早くお届け！',
      defaultDescription: 'サイトを訪れなくても通知で受け取れます（いつでも解除できます）',
      defaultDenyLabel: '今はしない',
      defaultAllowLabel: '受け取る',
      defaultIntervalDays: 1,
      secondsPerDay: 86400,

      maxLengths: {
        title: 50,
        description: 200,
        denyLabel: 20,
        allowLabel: 20,
      },
      requiredFields: [],
      intervalDaysRange: { min: 1, max: 90 },

      errors: {
        imageUrl: '',
        iconUrl: '',
        title: '',
        description: '',
        denyLabel: '',
        allowLabel: '',
        intervalDays: '',
      },
      acceptableMimeTypes: {
        iconUrl: ['image/png', 'image/jpeg'],
        imageUrl: ['image/png', 'image/jpeg', 'image/gif'],
      },

      isCopied: false,
      isChanged: false,

      styleSettings: {},
      isStyleDialogOpen: false,
      isIconCropperOpen: false,
      isImageCompressOpen: false,
    }
  },
  computed: {
    dialogValues() {
      return {
        imageUrl: this.imageUrl,
        iconUrl: this.iconUrl,
        title: this.title,
        description: this.description,
        denyLabel: this.denyLabel,
        allowLabel: this.allowLabel,
        style: this.styleSettings,
      };
    },
    hasStyleSettings() {
      return this.styleSettings && Object.keys(this.styleSettings).length > 0;
    },
    isDefaultIconUrl() {
      return this.iconUrl === DEFAULT_OPTIN_DIALOG_ICON_URL;
    },
    showChangedTooltip() {
      return this.isChanged
        && !this.isStyleDialogOpen
        && !this.isIconCropperOpen
        && !this.isImageCompressOpen;
    },
  },
  watch: {
    isActive(newVal) {
      if (!newVal) {
        this.isChanged = false;
      }
    },
    styleSettings: {
      deep: true,
      handler() {
        if (this.isStyleDialogOpen) {
          // モーダル開いている間は保存 API を叩かず、オプションタグ表示だけ更新
          this.generateScript();
        }
      },
    },
  },
  mounted() {
    this.setDefaultValues();
  },
  methods: {
    setDefaultValues: function () {
      const hasSavedData = this.applyInitialData();
      if (!hasSavedData) {
        this.iconUrl = this.projectIconUrl || DEFAULT_OPTIN_DIALOG_ICON_URL;
        this.title = this.defaultTitle;
        this.description = this.defaultDescription;
        this.denyLabel = this.defaultDenyLabel;
        this.allowLabel = this.defaultAllowLabel;
      }
      if (!this.intervalDays || this.intervalDays < 1) {
        this.intervalDays = this.defaultIntervalDays;
      }
      this.validateAll();
      this.generateScript();
      // 初期状態を保存済み扱いでキャッシュ(データ変更がない場合の save をスキップするため)
      this._lastSavedDataJson = this.buildSaveDataJson();
    },
    applyInitialData: function () {
      const data = this.initialData;
      if (!data) {
        return false;
      }
      this.imageUrl = data.imageUrl || '';
      this.iconUrl = data.iconUrl || '';
      this.title = data.title || '';
      this.description = data.description || '';
      this.denyLabel = data.denyLabel || '';
      this.allowLabel = data.allowLabel || '';
      if (data.intervalDays) {
        this.intervalDays = data.intervalDays;
      } else if (data.interval) {
        this.intervalDays = Math.max(1, Math.round(data.interval / this.secondsPerDay));
      }
      if (data.style && typeof data.style === 'object') {
        this.styleSettings = { ...data.style };
      }
      return true;
    },
    validateAll: function () {
      Object.keys(this.maxLengths).forEach(field => this.validateTextLength(field));
      this.checkIntervalDays();
    },
    validateTextLength: function (field) {
      const maxLength = this.maxLengths[field];
      const value = this[field] || '';
      if (this.requiredFields.includes(field) && !value) {
        this.errors[field] = '必須項目です';
        return;
      }
      if (value.length > maxLength) {
        this.errors[field] = `テキストは${maxLength}文字までです`;
      } else {
        this.errors[field] = '';
      }
    },
    generateScript: function () {
      let scriptContent = "<script>\n";
      scriptContent += "var pushonePreOptinDialogConfig = {\n";
      const lines = [];
      lines.push(`  version: 'v2'`);
      if (this.imageUrl) {
        lines.push(`  imageUrl: ${JSON.stringify(this.imageUrl)}`);
      }
      if (this.iconUrl) {
        lines.push(`  iconUrl: ${JSON.stringify(this.iconUrl)}`);
      }
      if (this.title) {
        lines.push(`  title: ${JSON.stringify(this.title)}`);
      }
      if (this.description) {
        lines.push(`  description: ${JSON.stringify(this.description)}`);
      }
      if (this.denyLabel) {
        lines.push(`  denyLabel: ${JSON.stringify(this.denyLabel)}`);
      }
      if (this.allowLabel) {
        lines.push(`  allowLabel: ${JSON.stringify(this.allowLabel)}`);
      }
      const intervalSeconds = (this.intervalDays || this.defaultIntervalDays) * this.secondsPerDay;
      lines.push(`  interval: ${intervalSeconds}`);
      if (this.hasStyleSettings) {
        const styleLines = Object.entries(this.styleSettings).map(
          ([key, value]) => `    ${key}: ${JSON.stringify(value)}`
        );
        lines.push(`  style: {\n${styleLines.join(',\n')}\n  }`);
      }
      scriptContent += lines.join(',\n') + "\n";
      scriptContent += "};\n";
      scriptContent += "</" + "script>";
      this.$refs.scriptTextarea.value = scriptContent;
    },
    onClipClick: function (event) {
      event.preventDefault();
      const text = $(`textarea[name="${this.data.copyId}"]`).prop('value');
      this.$copyText(text).then(function () {}, function () {});
    },
    isAcceptableMimeType: function (mimeType, targetField) {
      const list = this.acceptableMimeTypes[targetField] || [];
      return list.includes(mimeType);
    },
    mimeTypesLabel: function (targetField) {
      return (this.acceptableMimeTypes[targetField] || [])
        .map(m => m.replace('image/', '').replace('jpeg', 'JPEG').toUpperCase())
        .join('/');
    },
    selectImageFile: function () {
      const file = this.$refs.imageInput.files[0];
      if (!file) {
        return;
      }
      if (!this.isAcceptableMimeType(file.type, 'imageUrl')) {
        this.errors.imageUrl = `画像は${this.mimeTypesLabel('imageUrl')}形式のファイルを指定してください。`;
        return;
      }
      this.errors.imageUrl = '';
      const maxFileSize = 262144;
      // 256KB 以下ならそのままアップロード
      if (file.size <= maxFileSize) {
        this.uploadImageFile(file, 'imageUrl');
        return;
      }
      // GIF は Canvas 経由の圧縮で形式・アニメーションが失われるためエラー
      if (file.type === 'image/gif') {
        this.errors.imageUrl = 'GIF画像は256KB以下にしてください。';
        if (this.$refs.imageInput) {
          this.$refs.imageInput.value = '';
        }
        return;
      }
      // PNG/JPEG は圧縮モーダルを表示
      this.isImageCompressOpen = true;
      this.$refs.imageCompressModal.showModal(file);
    },
    onImageCompressed: function (compressedFile) {
      this.isImageCompressOpen = false;
      this.uploadImageFile(compressedFile, 'imageUrl');
      if (this.$refs.imageInput) {
        this.$refs.imageInput.value = '';
      }
    },
    onImageCompressCancelled: function () {
      this.isImageCompressOpen = false;
      if (this.$refs.imageInput) {
        this.$refs.imageInput.value = '';
      }
    },
    selectIconFile: function () {
      const file = this.$refs.iconInput.files[0];
      if (!file) {
        return;
      }
      if (!this.isAcceptableMimeType(file.type, 'iconUrl')) {
        this.errors.iconUrl = `画像は${this.mimeTypesLabel('iconUrl')}形式のファイルを指定してください。`;
        return;
      }
      this.errors.iconUrl = '';
      // 正方形かつ 8KB 以下ならそのままアップロード、それ以外はトリミング・圧縮モーダルを表示
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        const img = new Image();
        img.addEventListener('load', () => {
          const isSquare = img.width === img.height;
          const isSmallEnough = file.size <= 8192;
          if (isSquare && isSmallEnough) {
            this.uploadImageFile(file, 'iconUrl');
          } else {
            this.isIconCropperOpen = true;
            this.$refs.iconCropperModal.showModal(file);
          }
        });
        img.src = reader.result;
      });
      reader.readAsDataURL(file);
    },
    onIconCropped: function (croppedFile) {
      this.isIconCropperOpen = false;
      this.uploadImageFile(croppedFile, 'iconUrl');
      if (this.$refs.iconInput) {
        this.$refs.iconInput.value = '';
      }
    },
    onIconCropCancelled: function () {
      this.isIconCropperOpen = false;
      if (this.$refs.iconInput) {
        this.$refs.iconInput.value = '';
      }
    },
    clearImage: function () {
      this.imageUrl = '';
      this.errors.imageUrl = '';
      if (this.$refs.imageInput) {
        this.$refs.imageInput.value = '';
      }
      this.updateScript();
    },
    clearIcon: function () {
      this.iconUrl = '';
      this.errors.iconUrl = '';
      if (this.$refs.iconInput) {
        this.$refs.iconInput.value = '';
      }
      this.updateScript();
    },
    resetIcon: function () {
      this.iconUrl = this.projectIconUrl || DEFAULT_OPTIN_DIALOG_ICON_URL;
      this.errors.iconUrl = '';
      if (this.$refs.iconInput) {
        this.$refs.iconInput.value = '';
      }
      this.updateScript();
    },
    uploadImageFile: function (file, targetField) {
      this.errors[targetField] = '';

      if (!file) {
        return;
      }

      if (!this.isAcceptableMimeType(file.type, targetField)) {
        this.errors[targetField] = `画像は${this.mimeTypesLabel(targetField)}形式のファイルを指定してください。`;
        return;
      }

      const fileReader = new FileReader();
      fileReader.onload = () => {
        const offset = fileReader.result.indexOf(",") + 1;
        const base64 = fileReader.result.slice(offset);
        const data = `data:${file.type};base64,${base64}`;

        axios.post('/api/script-tag-setting/save-image', { icon: data })
          .then(response => {
            this[targetField] = response.data;
            this.updateScript();
          })
          .catch(() => {
            this.errors[targetField] = '画像のアップロードに失敗しました。';
          });
      };
      fileReader.readAsDataURL(file);
    },
    checkTitleLength: function () {
      this.validateTextLength('title');
    },
    checkDescriptionLength: function () {
      this.validateTextLength('description');
    },
    checkDenyLabelLength: function () {
      this.validateTextLength('denyLabel');
    },
    checkAllowLabelLength: function () {
      this.validateTextLength('allowLabel');
    },
    checkIntervalDays: function () {
      const { min, max } = this.intervalDaysRange;
      if (this.intervalDays === '' || this.intervalDays === null || this.intervalDays === undefined) {
        this.errors.intervalDays = '必須項目です';
        return;
      }
      if (this.intervalDays < min || this.intervalDays > max) {
        this.errors.intervalDays = `${min}〜${max}の範囲で入力してください`;
      } else {
        this.errors.intervalDays = '';
      }
    },
    onIntervalDaysChange: function (value) {
      const n = Number(value);
      this.intervalDays = isNaN(n) ? '' : n;
      this.checkIntervalDays();
      this.updateScript();
    },
    buildSaveDataJson: function () {
      const intervalSeconds = (this.intervalDays || this.defaultIntervalDays) * this.secondsPerDay;
      const data = {
        version: 'v2',
        imageUrl: this.imageUrl,
        iconUrl: this.iconUrl,
        title: this.title,
        description: this.description,
        denyLabel: this.denyLabel,
        allowLabel: this.allowLabel,
        interval: intervalSeconds,
        intervalDays: this.intervalDays,
        style: this.styleSettings,
      };
      return JSON.stringify(data);
    },
    saveOptionTagSettings: function () {
      const json = this.buildSaveDataJson();
      // データに変更がない場合はスキップ(画像なしの連打など、同じ状態の再送信を防ぐ)
      if (json === this._lastSavedDataJson) {
        return;
      }
      this._lastSavedDataJson = json;
      if (!location.pathname.endsWith('/onboarding/tag')) {
        this.isChanged = true;
      }
      axios.post('/api/script-tag-setting/save-option-v2', JSON.parse(json))
        .then(() => {})
        .catch(() => {
          // 保存失敗時はキャッシュを解除(そのままだと同一データの再送信がスキップされ Redis に反映されない)
          if (this._lastSavedDataJson === json) {
            this._lastSavedDataJson = null;
          }
        });
    },
    toggleCopyText: function () {
      this.isCopied = true;
      setTimeout(() => {
        this.isCopied = false;
      }, 2000);
    },
    updateScript: function () {
      this.generateScript();
      this.saveOptionTagSettings();
    },
    onOpenStyleModal: function () {
      this.isStyleDialogOpen = true;
    },
    onCloseStyleModal: function () {
      this.isStyleDialogOpen = false;
      // モーダル閉時にまとめて保存
      this.updateScript();
    },
    onStyleUpdate: function (newStyle) {
      this.styleSettings = { ...newStyle };
    },
  },
}
</script>

<style scoped>
:deep(.c-input__item::placeholder) {
    color: #d5d5d5;
    opacity: 1;
}
.p-dialog-option-v2__spec {
    font-size: 11px;
    color: #9a9a9a;
    margin-bottom: 4px;
}
.p-dialog-option-v2__image-row {
    display: flex;
    align-items: stretch;
    width: 680px;
}
.p-dialog-option-v2__image-row .c-input__item {
    flex: 1 1 auto;
    min-width: 0;
    width: auto;
    box-sizing: border-box;
    height: 40px;
    padding: 0 12px;
    font-size: 12px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}
.p-dialog-option-v2__file-btn {
    flex: 0 0 auto;
    display: inline-block;
    width: auto;
    padding: 0;
    margin: 0;
    cursor: pointer;
}
.p-dialog-option-v2__file-btn input[type="file"] {
    display: none;
}
.p-dialog-option-v2__file-btn .c-upload__btn {
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    padding: 0 10px;
    font-size: 14px;
    line-height: 1;
    white-space: nowrap;
    border-left: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    margin-left: -1px;
    background: #f6f8fa;
}
.p-dialog-option-v2__file-btn:hover .c-upload__btn {
    background: #eaeef2;
}
.p-dialog-option-v2__clear-btn {
    box-sizing: border-box;
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    padding: 0 10px;
    margin-left: 8px;
    background: #ffffff;
    color: #333;
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    line-height: 1;
    white-space: nowrap;
}
.p-dialog-option-v2__clear-btn:hover {
    background: #f6f8fa;
}
.p-dialog-option-v2__clear-btn--multiline {
    font-size: 12px;
    line-height: 1.2;
    padding: 4px 8px;
}
.p-dialog-option-v2__button-labels {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    width: 680px;
}
.p-dialog-option-v2__button-label-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1 1 0;
    min-width: 0;
}
.p-dialog-option-v2__button-label-caption {
    font-size: 14px;
    color: #57606a;
}
.p-dialog-option-v2__field-info {
    font-size: 12px;
    color: #8a8a8a;
    margin-top: 2px;
}
.p-dialog-option-v2__button-label-item .c-input__item {
    flex: 1 1 auto;
    min-width: 0;
    width: auto;
    box-sizing: border-box;
    height: 40px;
    padding: 0 12px;
}
.p-dialog-option-v2__interval-row {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    width: 680px;
}
.p-dialog-option-v2__interval-suffix {
    font-size: 14px;
    color: #333;
}
.p-dialog-option-v2__required {
    color: #d73a49;
    margin-left: 4px;
    font-weight: bold;
}
.p-dialog-option-v2__style-btn-row {
    display: flex;
    justify-content: flex-start;
    width: 680px;
}
.p-dialog-option-v2__style-btn {
    box-sizing: border-box;
    width: 200px !important;
    height: 40px;
    padding: 0 16px;
    font-size: 14px;
    line-height: 1;
    background: #9d9d9d;
}
.p-dialog-option-v2__style-btn .c-btn__text {
    font-size: 14px;
    padding: 0;
    margin: 0;
    line-height: 1;
}
</style>
